import React from "react";

const DimensionContext = React.createContext({});

const DimensionProvider = DimensionContext.Provider;

export { DimensionContext };
export default DimensionProvider;
